var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45312 16L6.67188 15.7812C6.57812 15.75 6.51562 15.6562 6.54688 15.5625L10.9531 0.15625C10.9844 0.0625 11.0781 0 11.1719 0.03125L11.9531 0.25C12.0469 0.28125 12.1094 0.375 12.0781 0.46875L7.67188 15.875C7.67188 15.9688 7.54688 16.0312 7.45312 16ZM5.07812 12.0938C5.04688 12.1562 4.92188 12.1562 4.85938 12.0938L0.359375 8.125C0.296875 8.0625 0.296875 7.96875 0.359375 7.90625L4.85938 3.9375C4.92188 3.875 5.04688 3.875 5.07812 3.9375L5.67188 4.59375C5.73438 4.65625 5.73438 4.75 5.64062 4.8125L1.85938 8L5.64062 11.2188C5.73438 11.2812 5.73438 11.375 5.67188 11.4375L5.07812 12.0938ZM13.7656 12.0938C13.7031 12.1562 13.5781 12.1562 13.5469 12.0938L12.9531 11.4375C12.8906 11.375 12.9219 11.2812 12.9844 11.2188L16.7656 8L12.9844 4.8125C12.9219 4.75 12.8906 4.65625 12.9531 4.59375L13.5469 3.9375C13.6094 3.875 13.7031 3.875 13.7656 3.9375L18.2656 7.90625C18.3281 7.96875 18.3281 8.0625 18.2656 8.125L13.7656 12.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.b8ebf93b6286276ce3d0739f0084a8b5.svg";
export { ForwardRef as ReactComponent };